import { ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  DataGridPro,
  DataGridProProps,
  GridColDef,
  GridColumnVisibilityModel,
  GridRowParams,
} from '@mui/x-data-grid-pro';
import { StyleObj } from '../../@types';
import { Bet } from '../../@types/api';
import { dataGridCellAlignmentSx, textLineClamp } from '../../styles/mixins';
import { mergeSx } from '../../utils/styles';

const styles: StyleObj = {
  dataGrid: (theme) => ({
    border: 'none',
    '& .MuiDataGrid-withBorderColor': {
      border: 'none',
    },
    '& .MuiDataGrid-columnHeader': {
      border: '1px solid #00533720',
      background: (theme) => theme.palette.background.lightGreen,
      '&:not(:first-of-type)': {
        borderLeft: 'none',
      },
    },
    '& .MuiDataGrid-cell': (theme) => ({
      border: 'none',
      fontWeight: 500,
      ...theme.typography.body3,
    }),
    '& .MuiDataGrid-row:nth-of-type(even)': {
      backgroundColor: 'background.light',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    '& .MuiDataGrid-columnHeaderTitle': (theme) => ({
      ...theme.typography.h5,
    }),
    '& .MuiDataGrid-columnHeader:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeaders': {
      borderRadius: 0,
    },
    '& .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeaders:hover .MuiDataGrid-columnSeparator': {
      visibility: 'hidden',
    },
    '& .MuiFormControl-root': {
      alignItems: 'center',
    },
    '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
      whiteSpace: 'normal !important',
      wordBreak: 'break-word !important',
      textAlign: 'center',
    },
    '& .MuiDataGrid-cellContent': textLineClamp(),
    '& .MuiDataGrid-detailPanel': {
      backgroundColor: 'background.lighter',
    },
  }),
};

type Props = {
  columns: GridColDef[];
  loading: boolean;
  visibleColumns: GridColumnVisibilityModel;
  bets: Bet[];
  getDetailPanelContent?: (params: GridRowParams<Bet>) => React.ReactNode;
};

const TicketAuthDetailsDataGrid = ({ columns, loading, visibleColumns, bets, getDetailPanelContent }: Props) => {
  return (
    <DataGridPro
      columns={columns}
      rows={bets}
      columnVisibilityModel={visibleColumns}
      loading={loading}
      disableColumnFilter
      disableColumnMenu
      disableColumnSelector
      disableRowSelectionOnClick
      pageSizeOptions={[20]}
      getRowHeight={() => 'auto'}
      columnHeaderHeight={44}
      hideFooterPagination
      sx={mergeSx(styles.dataGrid, dataGridCellAlignmentSx) as DataGridProProps['sx']}
      hideFooter
      getDetailPanelContent={getDetailPanelContent}
      getDetailPanelHeight={() => 'auto'}
      slots={{
        detailPanelExpandIcon: () => <ExpandMore />,
        detailPanelCollapseIcon: () => <ExpandLess />,
      }}
    />
  );
};

export default TicketAuthDetailsDataGrid;
